import { render, staticRenderFns } from "./NewsEntryDetail.vue?vue&type=template&id=56362029&scoped=true"
import script from "./NewsEntryDetail.vue?vue&type=script&lang=ts"
export * from "./NewsEntryDetail.vue?vue&type=script&lang=ts"
import style0 from "./NewsEntryDetail.scss?vue&type=style&index=0&id=56362029&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56362029",
  null
  
)

export default component.exports